import React from 'react';
import styled from '@emotion/styled';
import Helmet from 'react-helmet';
import { InternalLink, breakpoints } from 'gatsby-theme-apollo';
import { StaticQuery, graphql } from 'gatsby';

const StyledCrumbRenderer = styled.ol`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0px;
  width: 100%;
`;

const InternalLinkListItem = styled.li`
  font-weight: bold;
  text-decoration: none;
  list-style: none;
  margin: 0px 0px;
  padding: 0px 4px;
  font-size: 17px;
`;

const Separator = styled.span({
  padding: `3px`,
  opacity: `0.7`
});

const CrumbSpan = styled.span({
  fontSize: `16px`,
  [breakpoints.md]: {
    fontSize: `14px`
  }
});

const CrumbRenderer = ({ crumbs, header, baseCrumbH1 }) => (
  <StaticQuery
    query={graphql`
      {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `}
    render={data => {
      const { siteUrl } = data.site.siteMetadata;

      const visibleCrumbs = crumbs && crumbs.filter(crumb => !crumb.hide);
      let itemListElement = [];

      if (crumbs) {
        itemListElement = itemListElement.concat(
          crumbs.map(({ text, url }, index) => {
            const fullURL = `${siteUrl}/${url}`;
            return {
              '@type': `ListItem`,
              position: index + 1,
              item: {
                '@type': 'WebPage',
                name: text,
                '@id': fullURL,
                url: fullURL
              }
            };
          })
        );
      }

      const crumbJSON = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement
      };
      return (
        <>
          {crumbs && (
            <Helmet>
              <script type="application/ld+json">{JSON.stringify(crumbJSON)}</script>
            </Helmet>
          )}
          {visibleCrumbs && (
            <StyledCrumbRenderer>
              {visibleCrumbs.map((crumb, index) => {
                return (
                  <React.Fragment key={index}>
                    <InternalLinkListItem>
                      <InternalLink underline to={crumb.url}>
                        {baseCrumbH1 ? (
                          <h1 style={{ fontSize: '22px' }}>{crumb.text}</h1>
                        ) : (
                          <CrumbSpan>{crumb.text}</CrumbSpan>
                        )}
                      </InternalLink>
                    </InternalLinkListItem>

                    {!baseCrumbH1 && index < visibleCrumbs.length - 1 && <Separator>/</Separator>}
                  </React.Fragment>
                );
              })}
              {header}
            </StyledCrumbRenderer>
          )}
        </>
      );
    }}
  />
);

export default CrumbRenderer;
export { InternalLinkListItem };
